import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "wrap_1700" }
const _hoisted_3 = { class: "privacy_wrap" }
const _hoisted_4 = { class: "info_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalTerms = _resolveComponent("ModalTerms")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "logo_wrap icon_wrap" }, [
        _createElementVNode("img", {
          src: "img/logo.png",
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: "javascript:void(0)",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.state.isUserTerms = Boolean(true)))
        }, "이용약관"),
        _createElementVNode("a", {
          href: "javascript:void(0)",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.state.isPrivacyTerms = Boolean(true)))
        }, "개인정보처리방침")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString($setup.state.address.name), 1),
            _createElementVNode("p", null, _toDisplayString($setup.state.address.value), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString($setup.state.phone.name), 1),
            _createElementVNode("p", null, _toDisplayString($setup.state.phone.value), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString($setup.state.fax.name), 1),
            _createElementVNode("p", null, _toDisplayString($setup.state.fax.value), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString($setup.state.email.name), 1),
            _createElementVNode("p", null, _toDisplayString($setup.state.email.value), 1)
          ])
        ])
      ]),
      ($setup.state.isUserTerms)
        ? (_openBlock(), _createBlock(_component_ModalTerms, {
            key: 0,
            isShow: Boolean($setup.state.isUserTerms),
            title: $setup.state.use_terms.name,
            content: $setup.CommonUtils.decodeContent($setup.state.use_terms.value),
            onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isUserTerms = false))
          }, null, 8, ["isShow", "title", "content"]))
        : _createCommentVNode("", true),
      ($setup.state.isPrivacyTerms)
        ? (_openBlock(), _createBlock(_component_ModalTerms, {
            key: 1,
            isShow: Boolean($setup.state.isPrivacyTerms),
            title: $setup.state.privacy_terms.name,
            content: $setup.CommonUtils.decodeContent($setup.state.privacy_terms.value),
            onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.state.isPrivacyTerms = false))
          }, null, 8, ["isShow", "title", "content"]))
        : _createCommentVNode("", true)
    ])
  ]))
}